import { useEffect, useState, useMemo } from "react";

// Componentes
import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";
import { useGastosxMetodo } from "../../../../contexto/provider/GastosVistasContext.js";

import "./vistaTabla.css";

export default function TablaGastoXMetodo({ rowsPerPage = 8 }) {
  const { gastosMetodo, listarGastosMetodo } = useGastosxMetodo();
  const [paginaActual, setPaginaActual] = useState(1);

  const limiteFilas = Math.min(rowsPerPage, 20);
  const totalPaginas = Math.ceil(gastosMetodo.length / limiteFilas);

  const datosPaginados = useMemo(() => {
    const inicio = (paginaActual - 1) * limiteFilas;
    const fin = inicio + limiteFilas;
    return gastosMetodo.slice(inicio, fin);
  }, [gastosMetodo, paginaActual, limiteFilas]);

  const cambiarPagina = (numero) => {
    if (numero >= 1 && numero <= totalPaginas) {
      setPaginaActual(numero);
    }
  };

  // los filtros que uses
useEffect(() => {
  console.log("🚀 ejecutando effect");
  listarGastosMetodo({ rango: "hoy" });
}, [listarGastosMetodo]);


  return (
    <div>
      <TituloModulo titulo="Gastos por método de pago" />
      <BotonAccion onClick={() => listarGastosMetodo({ fuerza: true })}>
        Cargar
      </BotonAccion>
      <div className="tabla-container">
        <div className="tabla-scroll">
        <table className="tabla-reporte">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Método</th>
              <th className="col-num">Cantidad</th>
              <th className="col-num col-total">Total</th>
            </tr>
          </thead>
          <tbody>
            {datosPaginados.length === 0 ? (
              <tr>
                <td colSpan="4">Sin registros</td>
              </tr>
            ) : (
              datosPaginados.map((fila, index) => (
                <tr key={`${fila.fecha}-${fila.metodoPago}-${index}`}>
                  <td>{fila.fecha}</td>
                  <td>{fila.metodo_pago}</td>
                  <td className="col-num">{fila.cantidad_gastos}</td>
                  <td className="col-num col-total">
                    {new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                    }).format(fila.total)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
        <div className="paginacion">
          <button onClick={() => cambiarPagina(paginaActual - 1)}>←</button>

          <span>
            Página {paginaActual} de {totalPaginas || 1}
          </span>
          <button onClick={() => cambiarPagina(paginaActual + 1)}>→</button>
        </div>
      </div>
    </div>
  );
}
